import React, { useState } from 'react';
import Heading from 'app_previous/elements/typography/heading';
import Paragraph from 'app_previous/elements/typography/paragraph';
import { Link } from 'gatsby';
import { AiNameGeneratorWidgetContentfulModel } from 'src/api/models/AiNameGeneratorWidget';

import {
  Disclaimer,
  InlineNameGeneratorContainer,
  InlineNameGeneratorContent,
  InlineNameGeneratorThemesColors,
  SubheadContainer,
} from './InlineNameGenerator.styles';
import FreeBonusForm from './FreeBonusForm';
import { NameGeneratorHubspotFormProvider } from 'src/hooks/useNameGeneratorHubspotForm';
import InlineGenerator from '../../NameGenerator/InlineGenerator/InlineGenerator';

export interface InlineNameGeneratorProps {
  headline: string;
  subhead: string;
  placeholder: string;
  helperText: string;
  generatorMode: string;
  generatorSubject: string;
  theme?: AiNameGeneratorWidgetContentfulModel['theme'];
}

const InlineNameGenerator = ({
  headline,
  subhead,
  placeholder,
  helperText,
  generatorMode,
  generatorSubject,
  theme = 'Default',
}: InlineNameGeneratorProps): JSX.Element => {
  const [names, setNames] = useState<string[]>([]);

  const handleNameSuccess = (names: string[]) => {
    setNames(names);
  };

  const renderIsSuccess = (): JSX.Element => {
    if (names.length) {
      return (
        <FreeBonusForm
          title={headline}
          namesToShow={names}
          hubSpotId='de4f79f5-a706-4ce4-b137-f12ecf485b16'
          formWrapperId='profit-sales-header-form'
          backgroundColor={InlineNameGeneratorThemesColors[theme].formBackground}
        />
      );
    }
    return null;
  };

  return (
    <NameGeneratorHubspotFormProvider>
      <InlineNameGeneratorContainer>
        <InlineNameGeneratorContent themeKey={theme}>
          <Heading
            text={headline}
            standardSize='3.375'
            align='center'
            color={InlineNameGeneratorThemesColors[theme]?.text}
          />
          <SubheadContainer>
            <Paragraph
              text={subhead}
              standardSize='1.125'
              weight={'light'}
              align='center'
              color={InlineNameGeneratorThemesColors[theme]?.text}
            />
          </SubheadContainer>
          <InlineGenerator
            placeholder={placeholder}
            helperText={helperText}
            generatorMode={generatorMode}
            generatorSubject={generatorSubject}
            onSuccess={handleNameSuccess}
            colors={InlineNameGeneratorThemesColors[theme]}
          />
          <Disclaimer>
            <Paragraph
              standardSize='0.75'
              weight='light'
              align='center'
              color={InlineNameGeneratorThemesColors[theme]?.text}
            >
              The names generated by Mighty Co-Host™ are examples only and may be used by other businesses or subject
              to third-party rights. For more information, check our <Link to='/terms-of-use'>Terms</Link>.
            </Paragraph>
          </Disclaimer>
        </InlineNameGeneratorContent>
        {renderIsSuccess()}
      </InlineNameGeneratorContainer>
    </NameGeneratorHubspotFormProvider>
  );
};

export default InlineNameGenerator;
